"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableFilters = useTableFilters;
const react_1 = require("react");
function readStorage(storageKey) {
    // One-time migration: old 'tableFilters' → 'orders_tableFilters'
    if (storageKey === 'orders') {
        const oldStored = localStorage.getItem('tableFilters');
        const newStored = localStorage.getItem('orders_tableFilters');
        if (oldStored && !newStored) {
            localStorage.setItem('orders_tableFilters', oldStored);
            localStorage.removeItem('tableFilters');
            try {
                return JSON.parse(oldStored);
            }
            catch {
                return {};
            }
        }
    }
    const stored = localStorage.getItem(`${storageKey}_tableFilters`);
    if (stored) {
        try {
            return JSON.parse(stored);
        }
        catch {
            return {};
        }
    }
    return {};
}
function useTableFilters({ storageKey, filterKeys, onFilterChange, }) {
    const [filters, setFilters] = (0, react_1.useState)(() => readStorage(storageKey));
    const [showMobileSheet, setShowMobileSheet] = (0, react_1.useState)(false);
    const handleFilterChange = (0, react_1.useCallback)((newFilters) => {
        setFilters(newFilters);
        localStorage.setItem(`${storageKey}_tableFilters`, JSON.stringify(newFilters));
        onFilterChange?.();
    }, [storageKey, onFilterChange]);
    const handleRemoveFilter = (0, react_1.useCallback)((key, value) => {
        setFilters((prev) => {
            const updated = {
                ...prev,
                [key]: prev[key]?.filter((v) => v !== value) || [],
            };
            localStorage.setItem(`${storageKey}_tableFilters`, JSON.stringify(updated));
            onFilterChange?.();
            return updated;
        });
    }, [storageKey, onFilterChange]);
    const handleClearAll = (0, react_1.useCallback)(() => {
        const cleared = Object.fromEntries(filterKeys.map((k) => [k, []]));
        handleFilterChange(cleared);
    }, [filterKeys, handleFilterChange]);
    const activeFilterCount = (0, react_1.useMemo)(() => Object.values(filters).reduce((acc, v) => acc + (v?.length || 0), 0), [filters]);
    return {
        filters,
        activeFilterCount,
        handleFilterChange,
        handleRemoveFilter,
        handleClearAll,
        showMobileSheet,
        setShowMobileSheet,
    };
}
